export default __webpack_public_path__ + "static/media/talentAndPerformance.1ec11fe6.svg";